import * as React from 'react';
const getDisplayName = (Component)=>Component.displayName || Component.name || 'Component';
export default getDisplayName;
